var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.sumitBoxState,
          expression: "sumitBoxState",
        },
      ],
      staticClass: "submitBox",
    },
    [
      _c(
        "div",
        { staticClass: "sub_div_one" },
        [
          _vm.identity == "供应商"
            ? _c("span", [
                _vm._v(
                  " 亲，会尽快为您提供产品及价格回复。 您的会员手机号是： "
                ),
              ])
            : _c(
                "span",
                [
                  _vm._v(
                    " 亲，马上为您安排专业" +
                      _vm._s(_vm.identity) +
                      "和您对接，您希望 "
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "0.7rem" },
                      attrs: {
                        "popper-append-to-body": false,
                        size: "mini",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.customizerNum,
                        callback: function ($$v) {
                          _vm.customizerNum = $$v
                        },
                        expression: "customizerNum",
                      },
                    },
                    _vm._l(3, function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item },
                      })
                    }),
                    1
                  ),
                  _vm._v(
                    " 位" +
                      _vm._s(_vm.identity) +
                      "和您联系？您的会员手机号是： "
                  ),
                ],
                1
              ),
          _vm._v(
            " " +
              _vm._s(_vm.$store.state.userInfor.phoneNumber) +
              "， 是否需要补充您的第二联系号码 "
          ),
          _c("el-input", {
            staticStyle: { width: "1.2rem" },
            attrs: { placeholder: "联系电话", maxlength: "11", size: "mini" },
            on: {
              input: function ($event) {
                _vm.sparePhone = _vm.sparePhone.replace(/[^\d]/g, "")
              },
            },
            model: {
              value: _vm.sparePhone,
              callback: function ($$v) {
                _vm.sparePhone = $$v
              },
              expression: "sparePhone",
            },
          }),
          _vm._v(" 方便第一时间把方案送到您的手上。 "),
        ],
        1
      ),
      _c("div", { staticClass: "sub_div_two" }, [
        _vm.requestState
          ? _c("div", { staticClass: "sub_div_success" }, [
              _vm._v("询价已发送成功"),
            ])
          : _vm._e(),
        !_vm.requestState
          ? _c(
              "button",
              {
                staticStyle: {
                  background: "#fff",
                  border: "1px solid #dcdcdc",
                  color: "#333",
                },
                on: {
                  click: function ($event) {
                    _vm.sumitBoxState = false
                  },
                },
              },
              [_vm._v("再想想")]
            )
          : _c(
              "button",
              {
                staticStyle: {
                  background: "#fff",
                  border: "1px solid #dcdcdc",
                  color: "#333",
                },
                on: {
                  click: function ($event) {
                    _vm.sumitBoxState = false
                  },
                },
              },
              [_vm._v("关闭")]
            ),
        !_vm.requestState
          ? _c("button", { on: { click: _vm.saveSubmitAll } }, [_vm._v("发送")])
          : _c("button", { on: { click: _vm.goMyInquiry } }, [
              _vm._v("查看已发送的询价"),
            ]),
      ]),
      _c("div", { staticClass: "sub_div_three cleanFloat" }, [
        _c("div", { staticClass: "sdt_left" }, [
          _c("span", [_vm._v("提醒：")]),
          _c("ul", [
            _c("li", [
              _vm._v(
                "1）将在24小时内收到" + _vm._s(_vm.identity) + "给您的回复；"
              ),
            ]),
            _c("li", [
              _vm._v(
                "2）请您扫描并关注右侧二维码，" +
                  _vm._s(_vm.identity) +
                  "给您报价后，您将第一时间收到；"
              ),
            ]),
          ]),
        ]),
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sdt_right" }, [
      _c("img", {
        attrs: { src: require("../../assets/jpg/xiaochengxu.jpg"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }